import { useEffect, useState } from 'react';

export const XS_BREAKPOINT = 600;
export const SM_BREAKPOINT = 900;
export const MD_BREAKPOINT = 1280;
export const LG_BREAKPOINT = 1440;

const useDeviceSize = () => {
    const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setSize({ width: window.innerWidth, height: window.innerHeight });
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { ...size, isMobile };
};

export default useDeviceSize;
